import { render, staticRenderFns } from "./AlterVirtualTable.vue?vue&type=template&id=c4889ba0"
import script from "./AlterVirtualTable.vue?vue&type=script&lang=js"
export * from "./AlterVirtualTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports